import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataRoaming from "@/data/AdminPanel/DataRoaming";
import ApiRoaming from "@/api/ApiRoaming";
import sweetalert from "sweetalert";
import { Getter } from "vuex-class";
import EUserEnum from "@/struct/user/EUserEnum";
let RoamingZones = class RoamingZones extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataRoaming.Breadcrumbs;
        this.TableHeaders = DataRoaming.TableHeaders;
        this.TableItems = [];
        this.HasRequest = false;
    }
    CanAddAndEditAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin ||
                this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Editor));
    }
    CanDeleteAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin));
    }
    async getRoamingZones() {
        this.HasRequest = true;
        try {
            this.TableItems = await ApiRoaming.GetRoamingZones();
        }
        catch (e) {
            console.error(e);
        }
        this.HasRequest = false;
    }
    async DeleteItem(zone_uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("roaming.confirm_delete"),
            buttons: [
                this.$t("general.no"),
                this.$t("general.yes"),
            ],
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiRoaming.DeleteRoamingZone(ApiEnter.CurrentSessionUUID, zone_uuid);
                if (typeof response == "boolean") {
                    await sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    await this.getRoamingZones();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    mounted() {
        this.getRoamingZones();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], RoamingZones.prototype, "GetCurrentSessionUser", void 0);
RoamingZones = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], RoamingZones);
export default RoamingZones;
